module.exports = {
	"user": "EXAMPLE USER",
	"password": "EXAMPLE PASSWORD",
	"database": "EXAMPLE DATABASE",
	"port": "EXAMPLE PORT NUMBER",
	"host": "EXAMPLE HOST NAME"
};


//////////////////
// WEBPACK FOOTER
// ./app/js/credentials/redshift-example.credentials.json
// module id = 1412
// module chunks = 0